import {applyMiddleware, compose, createStore} from 'redux'
import ReduxThunk from 'redux-thunk'
import createRootReducer from './reducer'
import {batchMiddleware, batchReducerWrapper} from './batch'

let store
export const initStore = (initAppData, createReducer = createRootReducer) => {
    let _compose = compose
    if (process.env.NODE_ENV === 'development') {
        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
            _compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        }
    }

    store = createStore(
        batchReducerWrapper(createReducer(initAppData)),
        _compose(applyMiddleware(ReduxThunk, batchMiddleware))
    )
}

/**
 * Get instance of redux store
 * @returns {*}
 */
export const getStore = () => {
    return store
}



// WEBPACK FOOTER //
// ./web/js/redux/store.js